/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('DayHr_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/DayHrs/:id', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'},
        saveWithoutActivities: {method: 'POST', url: baseUrl + 'rest/DayHrs/withoutActivities'}
    });
}
]);

angular.module('FlexyBeautyApp.services').factory('DayHr', ["DayHr_Resource", "Activity", "DayHrData", "Period", "BookingService", "$log", "HumanResourceData",
    function (DayHr_Resource, Activity, DayHrData, Period, BookingService, $log, HumanResourceData) {
        //WorkingPeriodDay inherit of $resource

        var DayHr = function (resource, day, isPreviousVersion, isApplicationLoading) {
            this.id = null;
            this.humanResourceId = null;
            this.day = null;
            this.hasSpecificWpPeriods = false;
            this.hasSpecificOnLineBooking = false;
            this.onLineBooking = true;
            this.activities = [];
            this.periods = [];//Periods of work for a day;
            this.availablePeriods = [];
            this.comment = null;
            this.version = null;
            if (day !== undefined && day != null) {
                this.day = day;
            }

            if (resource !== undefined && resource != null) {
                this.loadObject(resource, isApplicationLoading);
            }
            if (isPreviousVersion == undefined || !isPreviousVersion)//A previous version is not added to DATA
                DayHrData.add(this);
        }
        DayHr.prototype.loadObject = function (object, isApplicationLoading) {
            this.loadObjectProperties(object);
            this.loadObjectActivities(object, isApplicationLoading);
        };
        DayHr.prototype.loadObjectProperties = function (object) {
            if (!this.id)
                this.id = object.id;
            this.humanResourceId = object.humanResourceId;
            this.hasSpecificWpPeriods = object.hasSpecificWpPeriods;
            this.hasSpecificOnLineBooking = object.hasSpecificOnLineBooking;
            this.onLineBooking = object.onLineBooking;
            this.comment = object.comment;
            if (object.periods) {
                this.periods = [];
                for (var j = 0; j < object.periods.length; j++)
                    this.addPeriodOnHr(object.periods[j]);
            }

            if (object.availablePeriods) {
                this.availablePeriods = [];
                for (var j = 0; j < object.availablePeriods.length; j++)
                    this.addAvailablePeriod(object.availablePeriods[j]);
            }
            if (object.version)
                this.version = object.version;
        };
        DayHr.prototype.hasBookingActivities = function () {
            for (var i = 0; i < this.activities.length; i++)
                if (this.activities[i].objectType != "Activity")
                    return true;
            return false;
        };
        DayHr.prototype.loadObjectActivities = function (object, isApplicationLoading) {
            if (object.activities) {

                let activitiesId = [];
                this.activities.forEach(activity => {
                    if (!activity.booking) {
                        activitiesId.push(activity.id);
                    }
                });

                for (let i = 0; i < object.activities.length; i++) {
                    //Could be an simple activity or a bookingService
                    if (object.activities[i].objectType == "Activity") {
                        if (activitiesId.indexOf(object.activities[i].id) === -1) {
                            let activity = new Activity(object.activities[i], null, isApplicationLoading);
                            activity.dayHr = this;
                            this.activities.push(activity);
                        }
                    } else {
                        let bs = this.day.getBookingServiceById(object.activities[i].id);
                        if (bs) {
                            if (bs._dayHrId == this.id)//primary link
                                bs.dayHr = this;
                            else
                                bs.addSecondaryDayHr(this);

                            this.activities.push(bs);
                        }
                    }
                }
            }
        };

        DayHr.prototype.addPeriodOnHr = function (period) {
            if (period)
                this.periods.push(new Period(period));
        }
        DayHr.prototype.addAvailablePeriod = function (period) {
            if (period)
                this.availablePeriods.push(new Period(period));
        }
        DayHr.prototype.getObjectResource = function () {
            var res = this.getObjectResourceWithoutActivities();
            //Add activities
            res.activities = [];
            if (this.activities)
                for (var i = 0; i < this.activities.length; i++)
                    res.activities.push(this.activities[i].getObjectResource());
            return res;
        }
        DayHr.prototype.getObjectResourceWithoutActivities = function () {
            //Get only Period data
            var res = new DayHr_Resource();
            res.id = this.id;
            res.humanResourceId = this.humanResourceId;
            res.hasSpecificWpPeriods = this.hasSpecificWpPeriods;
            res.hasSpecificOnLineBooking = this.hasSpecificOnLineBooking;
            res.onLineBooking = this.onLineBooking;
            res.comment = this.comment;
            if (this.day)
                res.dayId = this.day.id;
            //NoActivity
            res.periods = [];
            if (this.periods)
                for (var i = 0; i < this.periods.length; i++)
                    res.periods.push(
                        {
                            start:
                                {
                                    hour: this.periods[i].start.hour,
                                    minute: this.periods[i].start.minute
                                },
                            end:
                                {
                                    hour: this.periods[i].end.hour,
                                    minute: this.periods[i].end.minute
                                }
                        }
                    );

            return res;
        }
        DayHr.prototype.getObjectResourceCreatedByActivity = function () {
            //when created by activity : hasSpecificWpPeriods = false and periods is empty
            var res = new DayHr_Resource();
            res.id = this.id;
            res.humanResourceId = this.humanResourceId;
            if (this.day)
                res.dayId = this.day.id;
            return res;
        }
        DayHr.prototype.setId = function (id) {
            this.id = id;
        }
        DayHr.prototype.getId = function () {
            return this.id;
        }
        DayHr.prototype.addActivity = function (activity, isPrimary) {
            if (activity) {
                var index = this.activities.indexOf(activity);
                if (index == -1)
                    this.activities.push(activity);
                if (isPrimary === undefined || isPrimary)
                    activity.dayHr = this;
                else
                    activity.addSecondaryDayHr(this);
            }
        }
        DayHr.prototype.removeActivity = function (activity) {
            if (activity) {
                var index = this.activities.indexOf(activity);
                if (index != -1)
                    this.activities.splice(index, 1);
            }
        }
        DayHr.prototype.isOpenWorkingPeriodForHr = function (period) {
            var isOpen = false;
            for (var i = 0; i < this.periods.length && !isOpen; i++)
                isOpen = ((period.start.hour * 60 + period.start.minute) <
                        (this.periods[i].end.hour * 60 + this.periods[i].end.minute)) &&
                    ((period.end.hour * 60 + period.end.minute) >
                        (this.periods[i].start.hour * 60 + this.periods[i].start.minute));
            return isOpen;
        }
        DayHr.prototype.getHrWorkingTime = function () {
            var hrWorkingTime = 0;
            for (var i = 0; i < this.periods.length; i++)
                hrWorkingTime += this.periods[i].duration;
            return hrWorkingTime;
        }
        DayHr.prototype.getHrBookingTime = function () {
            var hrBookingTime = 0;
            for (var i = 0; i < this.activities.length; i++)
                if (this.activities[i] instanceof BookingService &&
                    this.activities[i].period &&
                    ((this.activities[i].booking && this.activities[i].booking.status != 'notCame') || (this.activities[i].pkg && this.activities[i].pkg.booking && this.activities[i].pkg.booking.status != 'notCame')))
                    hrBookingTime += this.activities[i].period.duration;
            return hrBookingTime;
        }
        DayHr.prototype.getActivityById = function (id) {
            for (var i = 0; i < this.activities.length; i++)
                if (this.activities[i].id == id)
                    return this.activities[i];
            return null;
        }
        DayHr.prototype.calculateMaxPeriod = function (period) {
            var hr = HumanResourceData.getById(this.humanResourceId);
            if (hr && !hr.isDeleted)
                for (var k = 0; k < this.periods.length; k++) {
                    if (this.periods[k] && this.periods[k].duration != 0) {
                        if ((this.periods[k].start.getTime()) < (period.start.getTime())) {
                            period.setStartHour(this.periods[k].start.hour);
                            period.setStartMinute(this.periods[k].start.minute);
                            console.log("Found max period on " + this.day.id + " hrid:" + this.humanResourceId)
                        }
                        if ((this.periods[k].end.getTime()) > (period.end.getTime())) {
                            period.setEndHour(this.periods[k].end.hour);
                            period.setEndMinute(this.periods[k].end.minute);
                            console.log("Found max period on " + this.day.id + " hrid:" + this.humanResourceId)
                        }
                    }
                }
        }
        return DayHr;
    }
]);

angular.module('FlexyBeautyApp.services').factory('DayHrSrv', [
    "$log", "DayHr_Resource", "DayHrData", "DayHr", "DayData", "ServerSrv", "UserActionData",
    function ($log, DayHr_Resource, DayHrData, DayHr, DayData, ServerSrv, UserActionData) {
        var DayHrSrv = {};

        DayHrSrv.save = function (dayHr, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(DayHrSrv.saveSync, dayHr, successFunction, errorFunction);
        };
        DayHrSrv.saveSync = function (dayHr, successFunction, errorFunction) {
            //$timeout (function () {

            var DayHrRes = dayHr.getObjectResource();
            DayHrRes.$save({}, //no params
                function (dayHrRes) {
                    try {
                        dayHr.setId(dayHrRes.id);
                        if (!dayHr.version || (dayHrRes.version && dayHrRes.version > dayHr.version))
                            dayHr.version = dayHrRes.version;
                        if (dayHrRes.activitiesId && dayHrRes.activitiesId.length == dayHr.activities.length)
                            //Assume that returned list has the same order
                            for (var i = 0; i < dayHrRes.activitiesId.length; i++)
                                dayHr.activities[i].setId(dayHrRes.activitiesId[i]);

                        //Add user action
                        UserActionData.add(dayHrRes.userAction);

                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(dayHrRes);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        };
        DayHrSrv.saveWithoutActivities = function (dayHr, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(DayHrSrv.saveSyncWithoutActivities, dayHr, successFunction, errorFunction);
        };
        DayHrSrv.saveSyncWithoutActivities = function (dayHr, successFunction, errorFunction) {
            //$timeout (function () {

            var DayHrRes = dayHr.getObjectResourceWithoutActivities();
            DayHrRes.$saveWithoutActivities({}, //no params
                function (dayHrRes) {
                    try {
                        dayHr.setId(dayHrRes.id);
                        if (!dayHr.version || (dayHrRes.version && dayHrRes.version > dayHr.version))
                            dayHr.version = dayHrRes.version;
                        if (dayHrRes.activitiesId && dayHrRes.activitiesId.length == dayHr.activities.length)
                            //Assume that returned list has the same order
                            for (var i = 0; i < dayHrRes.activitiesId.length; i++)
                                dayHr.activities[i].setId(dayHrRes.activitiesId[i]);

                        //Add user action
                        UserActionData.add(dayHrRes.userAction);

                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(dayHrRes);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        };
        DayHrSrv.remove = function (dayHr, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(DayHrSrv.removeSync, dayHr, successFunction, errorFunction);
        };
        DayHrSrv.removeSync = function (dayHr, successFunction, errorFunction) {
            //$timeout (function () {

            var DayHrRes = new DayHr_Resource();
            DayHrRes.$remove({id: dayHr.id}, //no params
                function (dayHrRes) {
                    if (!dayHr.version || (dayHrRes.version && dayHrRes.version > dayHr.version))
                        dayHr.version = dayHrRes.version;
                    //Remove from server success
                    // -> remove from local data
                    // -> add an user action (send message)

                    try {
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(dayHrRes);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        };

        DayHrSrv.updateLocally = function (id, resource) {
            let dayHr = DayHrData.getById(id);
            if (dayHr) {
                if (dayHr.version && resource.version && resource.version < dayHr.version) {
                    return null;
                }
                dayHr.loadObjectProperties(resource);
            } else {
                console.log("DayHr.updateLocally - Model not found given ID - DayHr ID: " + id);
            }
            return dayHr;
        };

        DayHrSrv.removeLocally = function (id, resource) {
            let dayHr = DayHrData.getById(id);
            if (dayHr) {
                if (dayHr.version && resource.version && resource.version < dayHr.version) {
                    return null;
                }

                if (dayHr.day) {
                    dayHr.day.removeDayHr(dayHr)
                } else {
                    console.log("DayHr.removeLocally - dayHr.day is null - DayHr ID: " + id);
                }
            } else {
                console.log("DayHr.removeLocally - Model not found given ID - DayHr ID: " + id);
            }
            return dayHr;
        };

        DayHrSrv.addLocally = function (id, resource) {
            let dayHr = DayHrData.getById(id);
            if (dayHr && dayHr.version && resource.version && resource.version < dayHr.version) {
                return null;
            }
            if (dayHr != null) {
                console.log("DayHr.addLocally - Model already exists - DayHr ID: " + id);
                dayHr.loadObjectProperties(resource);
            } else {
                let day = DayData.getById(resource.dayId);
                if (day) {
                    dayHr = new DayHr(resource, day);
                    dayHr.id = id;
                    day.addDayHr(dayHr);
                } else {
                    console.log("DayHr.addLocally - Day not found given ID - Day ID: " + resource.dayId);
                }
            }
            return dayHr;
        };

        DayHrSrv.getPreviousVersionInstance = function (resource) {
            var day = null;
            if (resource.dayId)
                day = DayData.getById(resource.dayId);
            var dayHr = new DayHr(resource, day, true);
            return dayHr;

        };

        return DayHrSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('DayHrData', [function () {
    var dayHrData = {
        indexDayHrs: []
    };
    dayHrData.getById = function (dayHrId) {
        for (var i = 0; i < this.indexDayHrs.length; i++)
            if (this.indexDayHrs[i].id == dayHrId)
                return this.indexDayHrs[i];
        return null;
    }
    dayHrData.getIndexOf = function (dayHr) {
        if (dayHr)
            return this.indexDayHrs.indexOf(dayHr);
        return -1;
    }
    dayHrData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexDayHrs.length)
            return this.indexDayHrs[index];
        return null;
    }
    dayHrData.add = function (dayHr) {
        this.indexDayHrs.push(dayHr);
        return this.indexDayHrs.length - 1;
    }
    dayHrData.clear = function () {
        this.indexDayHrs = [];
    }
    return dayHrData;
}
]);




// WEBPACK FOOTER //
// ./js/services/models/DayHr.js